// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4736) return "static/vendor.758c00c9.css";
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"4460":"ae7ac03b","5141":"4e018265","8358":"a9c2c79f","9086":"6b60cbee"}[chunkId] + ".css";
};